module.exports = __webpack_public_path__ + "img/article_1_6.15b5f391.png";